import { customRequest } from '@/shared/utils'
import { computeParams } from '@/shared/utils/to-params'

const enum API_URL {
    allPools = '/api/admin/v1/sub_accounts/pool/all',
    userPool = '/api/admin/v1/sub_accounts/user',
    updateUserPool = '/api/admin/v1/sub_accounts/user/pool/update/',
}

export function getAllPools() {
    return customRequest
        .getItem<any, any>(API_URL.allPools)
        .then((res) => res.data)
}

export function getUserPool(params: { user_id: number }) {
    return customRequest
        .getItem<any, any>(
            `${API_URL.userPool}/${params.user_id}/pool/`
        )
        .then((res) => res.data)
}

export function updateUserPool(body: {
    user_id: number
    pool_id: number
}) {
    return customRequest
        .post<any, any>(API_URL.updateUserPool, body)
        .then((res) => res.data)
}